const typesOfProduct = [
  {
    id: '',
    name: 'Todos los Productos'
  },
  {
    id: 1,
    name: 'Productos Vidroop'
  },
  {
    id: 0,
    name: 'Productos Comunes'
  }
]

export default typesOfProduct
